import React, { useState } from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Box, Grid, Typography, Card, CardMedia, useTheme, useMediaQuery, Modal, IconButton, styled } from '@mui/material';
import { Close } from '@mui/icons-material';
import { successStoriesMain } from '../../utils/BeadsData';


// const ImageWithZoom = styled(CardMedia)(({ theme }) => ({
//     transition: 'transform 0.5s ease',
//     '&:hover': {
//         transform: 'scale(1.05)',
//     },
//     height: 320,
//     objectFit: 'contain',
//     // borderRadius: '.6rem',
//     margin: '16px',
//     width: 'calc(100% - 32px)',
//     display: 'block',
//     marginLeft: 'auto',
//     marginRight: 'auto',
//     overflow: 'hidden',
//     '& img': {
//         borderRadius: 'inherit',
//     },
// }));
const ImageWithZoom = styled(CardMedia)(({ theme }) => ({
    transition: 'transform 0.5s ease',
    '&:hover': {
        transform: 'scale(1.05)',
    },
    height: 330,
    objectFit: 'cover',
    width: '100%',
    [theme.breakpoints.down('md')]: {
        objectFit: 'contain',
    },
}));

const ImageWrapper = styled(Box)(({ theme }) => ({
    overflow: 'hidden',
    borderRadius: '1rem',
    margin: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 330,
}));

const StoryCard = styled(Card)(({ theme }) => ({
    height: 400,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin: 'auto',
    overflow: 'hidden',
    borderRadius: '1rem',
    // border: '1px solid #cfcfcf'
}));

const SuccessStories = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [openModal, setOpenModal] = useState(false);
    const [selectedStory, setSelectedStory] = useState(null);

    const handleOpenModal = (story) => {
        setOpenModal(true);
        setSelectedStory(story);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setSelectedStory(null);
    };

    return (
        <Box>
            <NavBar />
            <Box
                sx={{
                    mt: 6,
                    backgroundImage: 'url("/assets/img/success-stories/Success-cover.jpg")',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    height: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <Typography variant={isMobile ? 'h3' : 'h2'} sx={{ color: '#fff', textShadow: '2px 2px 8px #000', fontWeight: 'bold', fontSize: { xs: '2rem', sm: '2rem', md: '4rem', textAlign: 'center' }, }}>
                    OUR SUCCESS STORIES
                </Typography>
            </Box>

            <Box sx={{ p: 3 }}>
                <Typography variant="body1" gutterBottom>
                    Most BEADS-sponsored girls are the first in their families to complete elementary school. There are hundreds of success stories that could be told, and we are proud of all our girls.
                </Typography>
                <Typography variant="body2" gutterBottom>
                    The stories shared here are only a few highlights (click each story for more details):
                </Typography>

                <Box sx={{ my: 5, textAlign: 'center', borderRadius: '1rem' }}>
                    <iframe
                        src='https://www.youtube.com/embed/YMb7anK9fIQ'
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        style={{ width: isMobile ? '100%' : '50%', height: '400px', borderRadius: '1rem', margin: 'auto' }}
                    ></iframe>
                </Box>

                <Grid container spacing={4}>
                    {successStoriesMain.map((story, index) => (
                        <Grid item xs={12} sm={6} md={4} key={index}>
                            <StoryCard onClick={() => handleOpenModal(story)}>
                                <ImageWrapper>
                                    <ImageWithZoom
                                        component="img"
                                        image={story.src}
                                        alt={story.alt}
                                    />
                                </ImageWrapper>
                                <Typography gutterBottom variant="h6" component="div" sx={{ textAlign: 'center', p: 1 }}>
                                    {story.title}
                                </Typography>
                            </StoryCard>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Modal
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: isMobile ? '90%' : 850,
                    maxHeight: '80vh',
                    overflowY: 'auto',
                    bgcolor: 'background.paper',
                    borderRadius: '1rem',
                    boxShadow: 24,
                    p: 4,
                    outline: 'none',
                }}>
                    <IconButton
                        aria-label="close"
                        onClick={handleCloseModal}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: 'common.white',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            borderRadius: '50%',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                            },
                            padding: '0.5rem',
                            margin: '-0.5rem',
                        }}
                    >
                        <Close />
                    </IconButton>
                    {selectedStory && (
                        <>
                            <CardMedia
                                component="img"
                                image={selectedStory.src}
                                alt={selectedStory.alt}
                                sx={{ borderRadius: '1rem', mb: 2, height: 'auto', maxWidth: '100%' }}
                            />
                            <Typography id="modal-modal-title" variant="h6" component="h2" textAlign='center'>
                                {selectedStory.title}
                            </Typography>
                            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                {selectedStory.description}
                            </Typography>
                        </>
                    )}
                </Box>
            </Modal>
            <FooterOne />
        </Box>
    );
};

export default SuccessStories;
